<template>
    <v-simple-table style="margin:30px 5px">
        <thead>          
            <th class="text-left"
                v-for="(item, index) in fields" 
                :key="index"
                :class="[
                    'size-x-small', 
                    item === 'amount' ? 'text-right' : 'text-left'
                  ]"     
                
              > 
             {{ titles[item] }} </th>
        </thead>
        <tbody>
            <tr v-for="(line, index) in dataRep" :key="index">       
                <td
                  v-for="(field, idx) in fields"
                  :key="idx"   
                  :class="[
                      'size-x-small', 
                      field === 'amount' ? 'text-right' : 'text-left'
                    ]"              
                >
                  {{ field === 'amount' ? $currency.format(line[field]) :
                    field === 'customer_usernameLogin' ? line['customer']['usernameLogin'] : 
                    field === 'customer_username' ? line['customer']['username'] : line[field] }}
                </td>
            </tr>
        </tbody>
        <tfoot v-if="showTotal">
        <tr>
          <td
            v-for="(field, idx) in fields"
            :key="'footer-' + idx"
            :class="[
              'size-x-small',
              field === 'amount' ? 'text-right font-bold' : 'text-left font-bold'
            ]"
          >
            <span v-if="field === 'amount'">
              {{ $currency.format(totalAmount) }}
            </span>
            <span v-else-if="idx === 0">Total</span>
          </td>
        </tr>
      </tfoot>
    </v-simple-table>   
</template>

<script>
export default {
  props: {
    dataRep: {
      type: Array,
      default: () => [],
    },
    
    showTotal: {
      type: Boolean,
      default: true
    }
  },  
  data: () => ({    
    titles: {
          paymentDate: 'Fecha',
          customer_usernameLogin: 'Lote',
          customer_username: 'Socio', 
          concept: 'Concepto',
          paymentMethod: 'Metodo de pago',         
          amount: 'Cantidad',                 
    },
    fields: ['paymentDate', 'customer_usernameLogin','customer_username','concept', 'paymentMethod', 'amount'],
  }),
  created() {
   console.log(this.dataRep);
  },
  computed: {
    totalAmount() {
      return this.dataRep.reduce((sum, line) => {
        return sum + (parseFloat(line.amount) || 0)
      }, 0)
    }
  },
}
</script>
<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>